import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";

type State = "" | "normal" | "error" | "ok";

export default class LoginInput extends ComponentBase{

  isPasswordVisible: boolean = false;

  $endIcon: any;
  $errorHint: any;

  constructor(elem: ComponentElem){
    super(elem);
    
    this.$endIcon = this.$root.find(".end-icon");
    this.$errorHint = this.$root.find(".error-hint");

    if(this.$root.attr("type") === "password")
    {
      this.$endIcon.on("click", (event:Event)=>
      {
        event.preventDefault();        
        this.isPasswordVisible = !this.isPasswordVisible;
        this.$root.find("input")[0].setAttribute("type", this.isPasswordVisible? "text": "password");
      }).css("visibility", "visible");
    }
    else if(this.$root.attr("type") === "text")
    {
    }
  }
  
  toggleState(state: State, errorText: string = "")
  {
    this.$root.attr("state", state);

    if(state === "error")
    {
      this.$errorHint.text(errorText);
    }
  }
}